import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { MyFormsList } from '@/features/forms/my-forms-list'

export const Route = createFileRoute('/_authenticated/_organization/my-forms/')(
  {
    component: MyFormsPage,
  }
)

function MyFormsPage() {
  const navigate = useNavigate()
  const { data: activeOrganization, isPending: isLoadingOrganization } =
    authClient.useActiveOrganization()

  useEffect(() => {
    if (!isLoadingOrganization && !activeOrganization) {
      navigate({
        to: '/errors/$error',
        params: { error: 'forbidden' },
        state: {
          message:
            'No organization found. Please create an organization first and wait for approval.',
        } as any,
        replace: true,
      })
    }
  }, [isLoadingOrganization, activeOrganization, navigate])

  if (!activeOrganization) {
    return null
  }

  return (
    <MyFormsList
      organizationId={activeOrganization.id}
      onOpenForm={(
        formId,
        { submissionId, clientId, assignmentId, isCompleted }
      ) => {
        // Completed forms are read-only — open the submission view.
        if (isCompleted && submissionId) {
          navigate({
            to: '/forms/$formId/submissions/$submissionId',
            params: { formId, submissionId },
          })
          return
        }
        // Otherwise open the fillable renderer — a new assigned form or
        // continuing a draft. Thread the assignment so the submission links to
        // the shift + recipient (the backend derives the target + shift link).
        navigate({
          to: '/forms/$formId/fill',
          params: { formId },
          search: {
            ...(submissionId ? { submissionId } : {}),
            ...(assignmentId ? { assignmentId } : {}),
            ...(clientId ? { clientId } : {}),
          },
        })
      }}
    />
  )
}
